<button type="button" class="btn btn-secondary" (click)="scrollToTarget()">
  Back to top
  <i class="bi bi-arrow-up"></i>
</button>
